import { Button } from "shared/Components/button";
import Modal from "shared/Components/modal";
import { pending, success } from "helper/icons";

export function EditQsModal({ modalRef, handleApply,onCloseModal, apiData}) {
  return (
    <Modal extraClass={`pt-0`} headerClass="sticky top-6 left-100 z-50" iconPosition="right-0" ref={modalRef}>
      <div className="p-8 pb-0 items-center m-auto">
        <img src={apiData.type == "error" ? pending : success} alt="" className="w-12 h-12 mb-4 m-auto" />
        <span className="text-xl font-semibold text-gray-900">{apiData.title}</span>
        {apiData.type !== "final" && (
           <div className="flex gap-2 justify-center mt-4">
            {apiData.type !== "error" && (
              <Button onClick={handleApply} disabled={apiData.loading} label="Yes" width="w-[120px]" />
            )}
            <button className="w-[120px] border border-gray-300 rounded-md hover:bg-gray-300 py-2" onClick={onCloseModal}>
              {apiData.type == "error" ? "Cancel" : "No"}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
}
